import { Box } from "@mui/material";
import { Loader } from "components/Loader";
import { useEffect, useState } from "react";

export const ImageLoader = ({ src, children }) => {
  const [isLoadedImage, setIsLoadedImage] = useState(true);

  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      setIsLoadedImage(false);
    };

    img.src = src;
  }, [src]);

  return (
    <>
      {isLoadedImage ? (
        <Box sx={{ height: "24px" }}>
          <Loader />
        </Box>
      ) : (
        children
      )}
    </>
  );
};
